export const setCookie = (cname, cvalue, exdays, options = {}) => {
  const { domain, path = "/", secure = true, sameSite = "Lax" } = options;

  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;

  const encodedValue = encodeURIComponent(cvalue);

  let cookieStr = `${cname}=${encodedValue}; ${expires}; path=${path}`;

  if (domain) cookieStr += `; domain=${domain}`;
  if (secure) cookieStr += `; Secure`;
  if (sameSite) cookieStr += `; SameSite=${sameSite}`;

  document.cookie = cookieStr;
};

export const getCookie = (cname) => {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [key, ...rest] = cookie.trim().split("=");
    if (key === cname) {
      return decodeURIComponent(rest.join("="));
    }
  }
  return null;
};
